import { Box } from '@mui/material';
import React from 'react';
import { Oval } from 'react-loader-spinner';

import { ReactComponent as Arrow } from 'assets/icons/arrow-down.svg';

import * as Styled from './styled';

const LoadingIndicator = () => {
	return (
		<Box sx={{ padding: '5px' }}>
			<Oval
				height={25}
				width={25}
				color="rgba(0, 0, 0, 0.26)"
				wrapperStyle={{}}
				wrapperClass=""
				visible={true}
				ariaLabel="oval-loading"
				secondaryColor="rgba(0, 0, 0, 0.26)"
				strokeWidth={5}
				strokeWidthSecondary={5}
			/>
		</Box>
	);
};

export const ArrowPagination = ({
	isLoadingEnd,
	isLoadingStart,
	hasMoreEnd,
	hasMoreStart,
	onEnd,
	onStart,
}: {
	isLoadingEnd: boolean;
	isLoadingStart: boolean;
	hasMoreEnd: boolean;
	hasMoreStart: boolean;
	onEnd: () => void;
	onStart: () => void;
}) => (
	<Styled.Pagination>
		{isLoadingEnd ? (
			<LoadingIndicator />
		) : (
			<Styled.PaginationButton
				disabled={!hasMoreEnd}
				onClick={onEnd}
				sx={{ transform: 'rotate(90deg)' }}
			>
				<Arrow />
			</Styled.PaginationButton>
		)}

		{isLoadingStart ? (
			<LoadingIndicator />
		) : (
			<Styled.PaginationButton
				disabled={!hasMoreStart}
				onClick={onStart}
				sx={{ transform: 'rotate(-90deg)' }}
			>
				<Arrow />
			</Styled.PaginationButton>
		)}
	</Styled.Pagination>
);
